import React from 'react';
import cl from './Comments.module.css';

const Stars = (props) => {
  switch (props.num) {
    case 1:
      console.log('1 star');
      return <i className={cl.one_star_icon}></i>;
      break;
    case 2:
      console.log('2 star');
      return <i className={cl.two_stars_icon}></i>;
      break;
    case 3:
      console.log('3 star');
      return <i className={cl.three_stars_icon}></i>;
      break;
    case 4:
      console.log('4 star');
      return <i className={cl.four_stars_icon}></i>;
      break;
    case 5:
      console.log('5 star');
      return <i className={cl.five_stars_icon}></i>;
      break;
    default:
      console.log(`Error?`);
      return <i className={cl.stars_icon}></i>;
  }
};

const Comments = (props) => {
  let featuredComment = props.comments?.map((c) => (
    <div className={cl.comment}>
      <div className={cl.comment_info}>
        <Stars num={Math.round(c.numberOfStars)} />
        <div className={cl.comment_info_name_and_date}>
          <p>{c.name}</p>
          <p>-</p>
          <p>{c.date}</p>
        </div>
        
      </div>
      <p className={cl.comment_text}>{c.text}</p>
      <img src={c.image}></img>
    </div>
  ));

  return (
    <section className={cl.comments_container}>
      <div className={cl.title}>
        <h1>Customer reviews</h1>
        <Stars num={Math.round(props.rating)} />
        <span>{props.rating} out of 5 stars</span>
      </div>
      <div className={cl.comments}>{featuredComment}</div>
    </section>
  );
};

export default Comments;
